import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2350165087/src/cloudix/src/app/[lang]/about-us/AboutUs.tsx");
